export default __webpack_public_path__ + "static/icon-import-export-df0656d42b5c59ad539c47dcbd0e6517.svg";